import React, { useState } from 'react';
import ToggleSwitch        from './ToggleSwitch';
import logoPng             from '../../assets/truscan_logo.png';
import { FaUserCircle }    from 'react-icons/fa';
import './SettingsPage.scss';

export default function SettingsPage() {
  /* local stub state (replace with a store or API later) */
  const [notif, setNotif]     = useState(true);
  const [remApp, setRemApp]   = useState(true);
  const [remMail, setRemMail] = useState(true);
  const [scale, setScale]     = useState('cm');   // 'cm' | 'kg'

  return (
    <div className="settings-page">
      {/* top bar */}
      <header className="top-bar">
        <img src={logoPng} alt="logo" className="logo" />
        <FaUserCircle className="avatar" />
      </header>

      {/* 1 ─ Notification */}
      <section className="group">
        <h3 className="group-title">NOTIFICATION SETTINGS</h3>
        <div className="row">
          <span>Turn on Notifications</span>
          <ToggleSwitch initial={notif} onChange={setNotif} />
        </div>
      </section>

      {/* 2 ─ Reminder */}
      <section className="group">
        <h3 className="group-title">REMINDER SETTINGS</h3>

        <div className="row">
          <span>Set up scan reminders<br />via app</span>
          <ToggleSwitch initial={remApp} onChange={setRemApp} />
        </div>

        <div className="row">
          <span>Set up scan reminders<br />via email</span>
          <ToggleSwitch initial={remMail} onChange={setRemMail} />
        </div>
      </section>

      {/* 3 ─ Scale */}
      <section className="group">
        <h3 className="group-title">SCALE FORMAT</h3>
        <div className="row scale-row">
          {['cm', 'kg'].map(opt => (
            <button
              key={opt}
              type="button"
              className={`scale-pill ${scale === opt ? 'active' : ''}`}
              onClick={() => setScale(opt)}
            >
              {opt.toUpperCase()}
            </button>
          ))}
        </div>
      </section>

      {/* bottom spacer under nav */}
      <div style={{ height: 24 }} />

      {/* ⬇ overlay banner */}
      <div className="coming-soon-overlay">
        <h2>Coming&nbsp;Soon</h2>
        <p>Settings will be available in a future update.</p>
      </div>
    </div>
  );
}
